export const systemDashboardIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Teacher Dashboard is where you can view key overview data on student usage and progress.'
  },
  {
    element: 'refresh-button',
    intro: 'Click here to refresh the Dashboard data.'
  },
  {
    element: '.form-check',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the report will only display '
      + 'those you are directly assigned to- excluding any students you\'re listed as a co-teacher for.',
  },
  {
    element: '#daily-notifications',
    intro: 'See the daily notifications for the current day. This includes both student celebration notifications and '
      + 'student needs attention notifications. Select Go to Notifications to go to the Recent Notifications page to learn more.'
  },
  {
    element: '#weekly-reminders',
    intro: 'See the Weekly Reminders for the three weekly goals teachers should be completing each week. Click View Results to see more details about each goal.'
  },
  {
    element: '#minutes-usage',
    intro: 'See the percentage of students who met their weekly time goal for the current week. Select Previous Week to see the percentage of students who met their weekly time goal for the previous week. Select View List to see the list of students included in each minute range.'
  },
  {
    element: '#unit-placement',
    intro: 'SSee the number of students working in each unit in the WordFlight System.'
  },
];
